"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateCost = void 0;
var numberPrices = [{
        upperLimit: 1500,
        price: 10
    }, {
        upperLimit: 2500,
        price: 7.1
    }, {
        upperLimit: 5000,
        price: 5.8
    }, {
        upperLimit: 10000,
        price: 4.46
    }, {
        upperLimit: 20000,
        price: 3
    }, {
        upperLimit: 50000,
        price: 1.7
    }, {
        upperLimit: 100000,
        price: 0.9
    }, {
        upperLimit: 250000,
        price: 0.55
    }, {
        upperLimit: 50000000,
        price: 0.42
    }];
function calculateCost(accountNumber) {
    if (accountNumber > 50000000)
        return null;
    /*if (accountNumber % 10 !== 0) {
        accountNumber /= 10;
        accountNumber = Math.ceil(accountNumber);
        accountNumber *= 10;
    }*/
    if (accountNumber >= 250000) {
        return 352700.00 + (accountNumber - 250000) * 0.55;
    }
    if (accountNumber >= 100000) {
        return 245400.00 + (accountNumber - 100000) * 0.72;
    }
    if (accountNumber >= 50000) {
        return 187000.00 + (accountNumber - 50000) * 1.17;
    }
    if (accountNumber >= 20000) {
        return 120700.00 + (accountNumber - 20000) * 2.21;
    }
    if (accountNumber >= 10000) {
        return 81700.00 + (accountNumber - 10000) * 3.90;
    }
    if (accountNumber >= 5000) {
        return 52800.00 + (accountNumber - 5000) * 5.79;
    }
    if (accountNumber >= 2500) {
        return 34000.00 + (accountNumber - 2500) * 7.54;
    }
    if (accountNumber >= 1500) {
        return 24700.00 + (accountNumber - 1500) * 9.22;
    }
    if (accountNumber >= 10) {
        return 5400.00 + (accountNumber - 10) * 13.00;
    }
    return 5400;
}
exports.calculateCost = calculateCost;
